var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.655,
    y1: 143.006,
    x2: 142.078,
    y2: 143.006
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.655,
    y1: 164.911,
    x2: 142.078,
    y2: 164.911
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.655,
    y1: 186.818,
    x2: 142.078,
    y2: 186.818
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M158.006,69.201h-72.77L56.392,94.235V208.13c0,5.684,4.65,10.334,10.334,10.334h91.279c5.684,0,10.334-4.65,10.334-10.334V79.535 C168.34,73.851,163.69,69.201,158.006,69.201z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: " 94.571,71.199 94.571,103.002 56.289,103.002  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M95.331,71.199V53.892h72.523c8.523,0,15.502,6.976,15.502,15.502v112.004H168.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M185.809,165.041h13.902V53.037c0-8.525-6.979-15.502-15.502-15.502h-72.523l0.679,16.356"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditional);
export default __webpack_public_path__ + "static/media/additional.3d5fe4210f7259c44dcc90f29b5ec716.svg";
export { ForwardRef as ReactComponent };